export const compareOfferings = (a, b) => {
    // rank all explicitly ordered offerings above others
    if ('_ordinal' in a) {
        if (!('_ordinal' in b)) return -1;
        if (a._ordinal < b._ordinal) return -1;
        if (a._ordinal > b._ordinal) return 1;
    } else if ('_ordinal' in b) {
        return 1;
    }

    // assumption is there are only `subscription` and `pack` types
    // subscriptions first, then class packs
    if (a.type === "subscription" && b.type != a.type) return -1;
    if (a.type === "pack" && b.type != a.type) return 1;

    if (a.type === "subscription") {
        // shorter first
        if (a.expiresIn < b.expiresIn) return -1;
        if (a.expiresIn > b.expiresIn) return 1;
    } else if (a.type === "pack") {
        // smaller packs first
        if (a.count < b.count) return -1;
        if (a.count > b.count) return 1;
    } else {
        console.warn(`unexpected offering type ${a.type}`);
    }

    // lex sort
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;

    // total ordering
    return a.id < b.id ? -1 : 1;
}
